export const REMOVE_OPTIONS_TEST_ID = 'RemoveOptions';
export const REMOVE_ITEM_CANCEL_BTN_TEST_ID = 'RemoveItemCancelBtn';
export const REMOVE_ITEM_REMOVE_BTN_TEST_ID = 'RemoveItemRemoveBtn';
